<template>
  <div class="player-event-detail college-event-detail">
    <div class="container">
      <a-row :gutter="32">
        <a-col :lg="16">
          <div class="event-detail">
            <div class="event-image">
              <img
                :src="generateImageUrl(athleteEvent.image)"
                alt="Event image"
                v-if="athleteEvent.image"
              />
            </div>
            <div class="event-title">{{ athleteEvent.title }}</div>
            <div class="event-info-wrap">
              <a-row :gutter="32">
                <a-col :md="12">
                  <div class="basic-info location-info">
                    <div class="heading">
                      <h2 class="head-title">Event Location Info</h2>
                    </div>
                    <div class="event-info">
                      <div class="info-detail">
                        <div class="info-title">Date</div>
                        <div class="info-content">
                          {{ getDate(athleteEvent.date) }}
                        </div>
                      </div>
                      <div class="info-detail">
                        <div class="info-title">Time</div>
                        <div class="info-content">
                          {{ athleteEvent.time }}
                        </div>
                      </div>
                      <div class="info-detail">
                        <div class="info-title">State/City</div>
                        <div class="info-content">
                          {{
                            `${athleteEvent && athleteEvent.state.name}/${
                              athleteEvent.city
                            }`
                          }}
                        </div>
                      </div>
                      <div class="info-detail">
                        <div class="info-title">Address</div>
                        <div class="info-content half-content">
                          {{ athleteEvent.location }}
                        </div>
                        <div class="info-content location">
                          <a
                            v-if="athleteEvent.googleLocation"
                            :href="athleteEvent.googleLocation"
                            target="_blank"
                          >
                            <a-icon type="pushpin" />View on map
                          </a>
                        </div>
                      </div>
                      <div class="info-detail">
                        <div class="info-title">Field</div>
                        <div class="info-content">{{ athleteEvent.field }}</div>
                      </div>
                    </div>
                  </div>
                </a-col>
                <a-col :md="12">
                  <div class="basic-info">
                    <div class="heading">
                      <h2 class="head-title">Basic Event Info</h2>
                    </div>
                    <div class="event-info">
                      <div class="info-detail">
                        <div class="info-title">Event Type</div>
                        <div class="info-content">
                          {{ athleteEvent.eventType.name }}
                        </div>
                      </div>
                      <div class="info-detail">
                        <div class="info-title">Age Group</div>
                        <div class="info-content">
                          {{ athleteEvent.age.name }}
                        </div>
                      </div>
                      <div
                        class="info-detail"
                        v-if="athleteEvent.eventType.name === 'Game Schedule'"
                      >
                        <div class="info-title">Team A</div>
                        <div class="info-content">{{ athleteEvent.teamA }}</div>
                      </div>
                      <div
                        class="info-detail"
                        v-if="athleteEvent.eventType.name === 'Game Schedule'"
                      >
                        <div class="info-title">Team B</div>
                        <div class="info-content">{{ athleteEvent.teamB }}</div>
                      </div>
                      <div
                        class="info-detail"
                        v-if="athleteEvent.sponser !== undefined"
                      >
                        <div class="info-title">Sponser</div>
                        <div class="info-content">
                          {{
                            athleteEvent.sponser ? athleteEvent.sponser : "none"
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
            <div class="event-description">
              <div class="heading">
                <h2 class="head-title">Event Description</h2>
              </div>
              <p>{{ athleteEvent.description }}</p>
            </div>
          </div>
        </a-col>
        <a-col :lg="8" v-if="filteredEventList.length > 0">
          <div class="other-events">
            <div class="heading">
              <h2 class="head-title">{{ sideTitle }}</h2>
            </div>
            <div class="events-list">
              <div
                class="event-card"
                v-for="(event, index) in filteredEventList"
                :key="index"
              >
                <div class="img-wrap">
                  <img
                    :src="generateImageUrl(event.image)"
                    alt="Event image"
                    v-if="event.image"
                  />
                </div>
                <div class="text-detail">
                  <div class="title">{{ event.title }}</div>
                  <div class="time-info">
                    <div class="date">{{ getDate(event.date) }}</div>
                    <div class="time">{{ event.time }}</div>
                  </div>
                  <div class="view-button" @click="changeEvent(event)">
                    View Details
                    <a-icon type="double-right" />
                  </div>
                </div>
              </div>
            </div>
            <div class="button-wrap">
              <router-link
                :to="
                  `/${profileId}/athelete/${$route.params.athleteProfileId}/events`
                "
              >
                <div class="view-all">View All Events</div>
              </router-link>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { Base } from "@/models";

const ATHLETE_EVENT_STORE_KEY = "athleteEventStore";

export default {
  name: "EventDetail",
  props: ["id"],
  data() {
    return {
      sideTitle: ""
    };
  },
  async created() {
    await this.$store.dispatch(`${ATHLETE_EVENT_STORE_KEY}/getAthleteEvent`, {
      id: this.$route.params.eventId,
      athleteProfileId: this.$route.params.athleteProfileId
    });
    this.sideTitle = "Upcoming Events";
    this.$store.dispatch(`${ATHLETE_EVENT_STORE_KEY}/getAthleteEventsList`, {
      "date[gte]": new Date(),
      sort: "date",
      profileId: this.$route.params.athleteProfileId,
      limit: 6
    });
  },
  computed: {
    ...mapGetters({
      athleteListEvents: `${ATHLETE_EVENT_STORE_KEY}/athleteListEvents`,
      athleteEvent: `${ATHLETE_EVENT_STORE_KEY}/athleteEvent`
    }),
    profileId() {
      return Base.profileId();
    },
    filteredEventList() {
      return this.athleteListEvents.filter(
        event => event.id !== this.$route.params.eventId
      );
    },
    hideSidebar() {
      if (this.filteredEventList.length === 0) return "no-side-bar";
      return "";
    }
  },
  methods: {
    getDate(date) {
      let d = new Date(date);
      return `${moment()
        .month(d.getUTCMonth())
        .format("MMM")} ${d.getUTCDate()}, ${d.getUTCFullYear()}`;
    },
    changeEvent(event) {
      this.$router.push(
        `/${this.$route.params.profileId}/athlete/${event.profileId._id}/event/${event.id}`
      );
    }
  }
};
</script>
